import React, { useEffect, useState, useRef } from 'react';
import { IconLibrary, ThriveIcon } from 'thrive-components';


interface SearchFilterButton {
    id: string,
    icon: React.ReactElement,
    setValue:(value: string) => void,
    buttonLabel: string,
    options: string[],
    defaultValue: string,
    canDeselect?: boolean
}

const SearchFilterButton = ({id, icon, setValue, buttonLabel, options, defaultValue, canDeselect}: SearchFilterButton) => {
    const dropdownRef = useRef<any>()
    const [showDropDown, setShowDropdown] = useState<boolean>(false);
    const [activeElement, setActiveELement] = useState<string>('')
    const [selectedElement, setSelectedElement] = useState<string>(defaultValue)
    const [focusIndex, setFocusIndex] = useState<number>(0)

    useEffect(() => {
        function handleClickOutside(event: Event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            
        };
    }, [])

    useEffect(() => {
        setValue(selectedElement)
    },[selectedElement])
    
    useEffect(() => {
        setSelectedElement(defaultValue)
    },[defaultValue])

    

    useEffect(() => {
        if (!showDropDown) {
            setActiveELement(``)
            setFocusIndex(0);
        }
    }, [showDropDown])

    useEffect(() => {
        if(showDropDown) {
            setAndFocusNextElement(getElementName(focusIndex))
        }
    },[focusIndex, showDropDown])

    function handleKeyPressOnButton(e: any) {
        switch(e.key) {
            case 'ArrowDown':
            case 'ArrowUp': 
            case 'Space':
            case ' ':
            case 'Enter':
            case 'Home':
            case 'End':
                e.preventDefault();
                setShowDropdown(!showDropDown);
                setFocusIndex(e.key === 'End' ? options.length -1 : 0)
                break;
            case 'Tab':
                setShowDropdown(false);
                break;
        }
    }

    function handleKeyPressInList(e: any) {
        e.preventDefault();
        switch(e.key) {
            case 'Tab':
                setSelectedElement((canDeselect && options[focusIndex] === selectedElement) ? '' : options[focusIndex])
                setShowDropdown(false);
            document.getElementById(`${id}-open-menu-button`)?.focus();     
                break;
            case 'Enter':
            case 'Space':
            case ' ':
                setSelectedElement((canDeselect && options[focusIndex] === selectedElement) ? '' : options[focusIndex])
                setShowDropdown(false);
                document.getElementById(`${id}-open-menu-button`)?.focus();
                break;
            case 'ArrowDown':
                e.preventDefault();
                setFocusIndex(focusIndex + 1 >= options.length ? 0 : focusIndex + 1)
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusIndex(focusIndex - 1 < 0  ? options.length -1 : focusIndex - 1)
                break;
            case 'Home':
                e.preventDefault();
                setFocusIndex(0)
                break;
            case 'End':
                e.preventDefault();
                setFocusIndex(options.length -1)
                break;
            case 'Esc':
                setShowDropdown(false);
                document.getElementById(`${id}-open-menu-button`)?.focus();
                break;

        }
    }

    function setAndFocusNextElement(elementId: string){
        if(!elementId) { return; }

        const element = document.getElementById(elementId)
        if (element) {
            element.focus();
        }
    }

    function getElementName(index: number) {
        return `${id}-option-${index}`
    }
    
    return (
        <div className='search-drop-down-button-container' ref={dropdownRef}>
            <button 
                id={`${id}-open-menu-button`}
                className='search-dd-button'
                onClick={() => {setShowDropdown(!showDropDown)}}
                role='combobox'
                aria-controls={id}
                aria-owns={id}
                aria-expanded={showDropDown}
                aria-activedescendant={activeElement}
                onKeyDown={(e) => handleKeyPressOnButton(e)}
            >
                {icon}
                <span className='dd-button-label'>{buttonLabel}</span>
                {!!selectedElement && <span className='selected-count'>{1}</span>}
                <ThriveIcon 
                    iconName={IconLibrary.CHEVRON_DOWN}
                    sizeInPx='7'            
                />
            </button>
            {showDropDown && <div 
                className='search-drop-down-container'
                id={id}
                role='listbox'
            >
                {options.map((el, idx) => {
                    return (<div 
                        tabIndex={-1}
                        className={`search-dd-option ${selectedElement === el ? 'selected' : activeElement ===  `${id}-option-${idx}` ? 'active' : ''}`}
                        key={`${id}-option-${idx}`}
                        id={`${id}-option-${idx}`}
                        role='option'  
                        onMouseOver={()=>{
                            setActiveELement(`${id}-option-${idx}`)}
                        }
                        onClick={() => {
                            setSelectedElement((canDeselect && el === selectedElement) ? '' : el);
                            setShowDropdown(false);
                        }}
                        onKeyDown={(e) => handleKeyPressInList(e)}
                        onFocus={() => setActiveELement(`${id}-option-${idx}`)}
                    >
                       {el}
                    </div>
                )})}
                
            </div>}
        </div>

    )

}

export default SearchFilterButton;